<template>
  <PForm
    v-model="validado"
    @cancel="limpiar"
    @accept="action"
    :action="actionName"
    :textAction="textActionName"
    :textCancel="$t('action.limpiar')"
  >
    <template>
      <PRow>
        <PCol md="12">
          <PFormInputText
            v-model="valueLocal.documentTitle"
            :label="$t('label.nomFichero')"
          ></PFormInputText>
        </PCol>
        <PCol md="12">
          <PFormInputText
            v-model="valueLocal.documentType"
            :label="$t('label.tipoDocumento')"
          ></PFormInputText>
        </PCol>
        <PCol md="12">
          <PFormSelect
            v-model="valueLocal.estado"
            :options="estados"
            optionValue="codEstado"
            optionText="descriptionEstado"
            :label="$t('label.estado')"
            :placeholder="$t('option.select')"
          >
          </PFormSelect>
        </PCol>
        <PCol md="12">
          <PFormInputText
            v-model="valueLocal.aprobadoPor"
            :label="$t('label.aprobadoPor')"
          ></PFormInputText>
        </PCol>
        <PCol md="12">
          <PFormSelectMulti
            v-model="valueLocal.delegationsSelected"
            :options="delegations"
            optionValue="codDelegacionSol"
            optionText="desDelegacion"
            :label="$t('label.delegaciones')"
            :placeholder="$t('option.select')"
            :readonly="delegations.length === 0"
          />
        </PCol>
        <PCol md="12">
          <PFormDatepicker
            v-model="valueLocal.fechaArchivoInicio"
            :label="$t('label.fechaArchivoInicio')"
            :language="locale"
          ></PFormDatepicker>
        </PCol>
        <PCol md="12">
          <PFormDatepicker
            v-model="valueLocal.fechaArchivoFin"
            :label="$t('label.fechaArchivoFin')"
            :language="locale"
          ></PFormDatepicker>
        </PCol>
        <PCol md="12">
          <PFormDatepicker
            v-model="valueLocal.fechaSubidaInicio"
            :label="$t('label.fechaSubidaInicio')"
            :language="locale"
          ></PFormDatepicker>
        </PCol>
        <PCol md="12">
          <PFormDatepicker
            v-model="valueLocal.fechaSubidaFin"
            :label="$t('label.fechaSubidaFin')"
            :language="locale"
          ></PFormDatepicker>
        </PCol>
        <PCol md="12">
          <PFormInputText
            v-model="valueLocal.usuario"
            :label="$t('label.usuario')"
          ></PFormInputText>
        </PCol>
      </PRow>
    </template>
  </PForm>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { ICliente, IDelegacion } from "@/entities";
import { Locale } from "@/store";
import VueMethods from "@/vue-methods";
import { IDocumentacionImportacionFilters } from "@/services";

@Component({
  mixins: [VueMethods],
})
export default class DocumentacionImportacionTableFilters extends Vue {
  @Prop({ required: false })
  textActionName!: string;
  @Prop({ required: false })
  actionName!: string;
  @Prop({ required: false })
  maxRangeMonth?: number;

  @Getter("getLocale") locale!: Locale;
  @Getter("getClienteSelected") clienteSelected!: ICliente;

  @Prop({ required: true }) value!: IDocumentacionImportacionFilters;
  @Watch("value", { immediate: true, deep: true })
  onChangeValue(): void {
    this.valueLocal = JSON.parse(JSON.stringify(this.value));
    this.$set(
      this.valueLocal,
      "fechaArchivoInicio",
      this.valueLocal.fechaArchivoInicio ? new Date(this.valueLocal.fechaArchivoInicio!) : null
    );
    this.$set(
      this.valueLocal,
      "fechaArchivoFin",
      this.valueLocal.fechaArchivoFin ? new Date(this.valueLocal.fechaArchivoFin!) : null
    );
    this.$set(
      this.valueLocal,
      "fechaSubidaInicio",
      this.valueLocal.fechaSubidaInicio ? new Date(this.valueLocal.fechaSubidaInicio!) : null
    );
    this.$set(
      this.valueLocal,
      "fechaSubidaFin",
      this.valueLocal.fechaSubidaFin ? new Date(this.valueLocal.fechaSubidaFin!) : null
    );
  }
  validado = false;
  valueLocal: IDocumentacionImportacionFilters = {
    documentTitle: "",
    documentType: "",
    delegationsSelected: [],
    fechaArchivoInicio: "",
    fechaArchivoFin: "",
    fechaSubidaInicio: "",
    fechaSubidaFin: "",
    usuario: "",
    estado: "",
    aprobadoPor: "",
  };

  initialValueLocal: IDocumentacionImportacionFilters = {
    documentTitle: "",
    documentType: "",
    delegationsSelected: [],
    fechaArchivoInicio: "",
    fechaArchivoFin: "",
    fechaSubidaInicio: "",
    fechaSubidaFin: "",
    usuario: "",
    estado: "",
    aprobadoPor: "",
  };

  get delegations(): IDelegacion[] {
    let delegationsList: IDelegacion[] = [];
    this.clienteSelected?.clientexdels.forEach((clientexdel) => {
      if (clientexdel.active) delegationsList.push(clientexdel.delegacion);
    });
    return delegationsList.sort((a, b) => this.sortAscending(a, b, "desDelegacion"));
  }

  limpiar(): void {
    this.valueLocal.fechaArchivoInicio = "";
    this.valueLocal.fechaArchivoFin = "";
    this.valueLocal.fechaSubidaInicio = "";
    this.valueLocal.fechaSubidaFin = "";
    this.valueLocal.delegationsSelected = [];
    this.valueLocal.documentType = "";
    this.valueLocal.usuario = "";
    this.valueLocal.documentTitle = "";
    this.valueLocal.estado = "";
    this.valueLocal.aprobadoPor = "";
    if (!this.isInitialObject(this.value, this.initialValueLocal)) {
      this.$emit("input", this.valueLocal);
      this.$emit("cancel", { action: "clean" });
    }
  }
  action(action: string): void {
    this.$emit("input", this.valueLocal);
    this.$emit("action", { action: action });
  }
  get estados(): any[] {
    return [
      { codEstado: "PENDIENTE", descriptionEstado: this.$t("label.estado.documento.pendiente") },
      { codEstado: "PROCESADO", descriptionEstado: this.$t("label.estado.documento.procesado") },
      { codEstado: "ERROR", descriptionEstado: this.$t("error") },
      {
        codEstado: "PENDIENTE_APROBACION",
        descriptionEstado: this.$t("label.estado.documento.pendiente-aprobacion"),
      },
    ];
  }
}
</script>
